import React, { useContext } from 'react';
import { AuthContext } from './firebase/auth';
import Game from './components/Game';
import Loading from './components/Loading';

function App() {
  const { isAuthenticated, loggedInUser } = useContext(AuthContext);
  
  return (
    <>
        {isAuthenticated && loggedInUser ? <Game /> : <Loading /> }
    </>
  );
}

export default App;
